/// <amd-module name="Pipeline/Analytics/PipelineOutcome/FailingTaskGrid/Stores/PipelineOutcomeFailingTaskGridStore" />
import { IPipelineReportBaseState, PipelineReportBaseStore } from "Pipeline/Analytics/Common/Stores/PipelineReportBaseStore";
import { PipelineOutcomeFailingTaskGridActions } from "Pipeline/Analytics/PipelineOutcome/FailingTaskGrid/Actions/PipelineOutcomeFailingTaskGridActions";
import { ITaskData } from "../Types";

export interface IPipelineOutcomeFailingTaskGridState extends IPipelineReportBaseState<ITaskData[]> {}

export class PipelineOutcomeFailingTaskGridStore extends PipelineReportBaseStore<
    PipelineOutcomeFailingTaskGridActions,
    IPipelineOutcomeFailingTaskGridState,
    ITaskData[]
> {}
